import { CrudOp, megTemplateAuthScope } from "@org-avp/avp-avengers-ui-shared-auth";
import { MegTemplateIcon } from "@org-avp/avp-avengers-ui-shared-icons";
import { Translations, ViewIsAuthorized, ViewModule } from "@org-avp/avp-avengers-ui-shared-utils";
import de from "../../public/locales/de.json";
import en from "../../public/locales/en.json";
import { MegTemplateView } from "./lazy-view";

const translations: Translations = { de, en };
const isAuthorized: ViewIsAuthorized = (authHelperCreator, { project }) => {
  const authHelper = authHelperCreator(megTemplateAuthScope);
  return project != null && authHelper.evaluate(CrudOp.READ, project);
};

export const megTemplateViewKey = "qa_modular_meg-template/:projectId/:subprojectId";
export const megTemplateViewModule: ViewModule = {
  viewKey: megTemplateViewKey,
  viewEl: <MegTemplateView/>,
  displayNameI18nKey: "megTemplate:viewName",
  menuIconEl: <MegTemplateIcon/>,
  isAuthorized,
  translations,
};
